/**
 * Minimal amount formatting helpers for the Nado deposit flow.
 * These avoid pulling in the heavy @vertex-protocol/react-client formatter
 * for simple numeric display needs.
 */

/**
 * Format a numeric amount to a fixed number of decimal places,
 * stripping trailing zeros.
 *
 * @param value - The numeric value to format
 * @param maxDecimals - Maximum decimal places to show (default 6)
 */
export function formatAmount(value: number, maxDecimals = 6): string {
  if (!isFinite(value)) return '0';
  return parseFloat(value.toFixed(maxDecimals)).toString();
}

/**
 * Format a token amount for display (e.g. USDT0 with 6 decimals).
 *
 * @param rawAmount - The amount string from an input field
 * @param decimals - Token decimals (default 6 for USDT0/USDT)
 */
export function formatTokenAmount(
  rawAmount: string,
  decimals = 6,
): string {
  const parsed = parseFloat(rawAmount);
  if (isNaN(parsed)) return '0';
  return formatAmount(parsed, decimals);
}
